import script from "./HierarchicalBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./HierarchicalBranch.vue?vue&type=script&setup=true&lang=js"

import "./HierarchicalBranch.vue?vue&type=style&index=0&id=9b80df6e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b80df6e"]])

export default __exports__